import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeAttribute } from '../../models/documentTypeAttribute.model';


@Pipe({
  name: 'sortFilter'
})
export class SortFilterPipe implements PipeTransform {

  transform(sortAttributes: DocumentTypeAttribute[]): any {
    //check if the search term is defined
    if(!sortAttributes) return sortAttributes;

    return sortAttributes.filter(item => item.code !== 'string');
  }

}